import { ItemInterface } from "@/interface/app/ooc";
import { PricingType } from "@/types/app/ooc/pricing.type";
import { ModifierList, Variation } from "@/modules/ooc/index";
import { ItemType } from "@/types/app/ooc/item.type";

export default class Item implements ItemInterface {
  id: string = "";
  external_id: string = "";
  plu: string = "";
  in_menu: boolean = false;
  category_id: string = "";
  pricing: Array<PricingType> = [];
  modifier_list: any = {};
  taxes: Array<any> = [];
  name: string = "";
  original_name: string = "";
  original_local_name: string = "";
  local_name: string = "";
  description: string = "";
  image_url: string = "";
  local_description: string = "";
  variations: Array<any> = [];
  staged: boolean = false;

  public static MODULE_NAME: string = "ooc/items";

  constructor(data?: ItemType) {
    if (data) {
      this.image_url = data.image_url || "";
      this.local_description = data.local_description || "";
      this.name = data.name || "";
      this.original_name = data.name || "";
      this.plu = data.plu || "";
      this.id = data.id || "";
      this.local_name = data.local_name || "";
      this.original_local_name = data.local_name || "";
      this.external_id = data.external_id || "";
      this.category_id = data.category_id || "";
      this.description = data.description || "";
      this.staged = false;
      this.modifier_list = data.modifier_list.map((list) => {
        return new ModifierList(list);
      });
      this.variations = data.variations.map((variation) => {
        return new Variation(variation);
      });
    }
  }
}
